<template>
    <q-card style="width: 400px; max-width: 80vw;">
      <q-card-section>
        <div class="text-weight-bold text-h6 text-center q-pa-sm">{{ $t('event.selectTickets') }}
          {{ selection.section.label }}</div>
        <div class="row justify-evenly q-pt-lg">
          <div class="col-md-6">
            <div>{{ selection.category.name }}</div>
            <div v-if="selection.category.defaultPromotion != null">
              <del>{{ selection.category.price }} {{ selection.category.currency }}</del>&nbsp;
              <span class="text-primary">{{ selection.category.defaultPromotion.price }}
                {{ selection.category.currency }}</span>
            </div>
            <div v-else>
              <span>{{ selection.category.price }} {{ selection.category.currency }}</span>
            </div>
          </div>
          <div class="col-md-6">
            <q-btn-group size="xs">
              <q-btn
                padding="md"
                size="md"
                dense
                color="primary"
                icon="remove"
                @click="noTickets > 1 ? noTickets-- : noTickets"
              />
              <input
                class="flat-tickets-no"
                v-model="noTickets"
                type="number"
              />
              <q-btn
                padding="md"
                dense
                size="md"
                color="primary"
                icon="add"
                @click="noTickets++"
              />
            </q-btn-group>
          </div>
        </div>
      </q-card-section>
      <q-separator inset />
      <q-card-section>
        <q-btn
          color="primary"
          no-caps
          class="full-width"
          @click="selectTickets(noTickets)"
        >{{ $t('event.select') }}</q-btn>
      </q-card-section>
    </q-card>
  </template>
  
  <script>
  
  export default {
    name: 'flat-section-select',
    props: {
      selectedTickets: {
        required: true
      },
      selection: {
        required: true
      },
      selectTickets: {
        type: Function,
        required: true
      }
    },
    created: function () {
      this.noTickets = this.selectedTickets !== null ? this.selectedTickets : 2;
    },
    data: function () {
      return {
        noTickets: null
      }
    },
    methods: {
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .flat-tickets-no {
    max-width: 50px;
    text-align: center;
  }
  </style>
  